export const TRANSACTION_LIST_CTX_TRANSACTIONS_VIEW = 'transactionsView';
export const TRANSACTION_LIST_CTX_MOCK_SERVICE_TEMPLATE_DETAILS = 'mockServiceDetails.serviceMockTemplateTransactions';
export const LEARN_MORE = 'learnMore';
